import { useEffect, useMemo, useRef } from 'react';
import { deepEqual } from 'fast-equals';
import { fillEmptyValues } from '../form-values';
import { normalizeValues } from './normalize-values';
import { autofillValues } from '../../components/form/autofill';
export const useFormValues = (form, values, onChange, config, enableAutofill) => {
    const hasAutofilled = useRef(false);
    const normalizedValues = useMemo(() => {
        let filled = fillEmptyValues(form, values);
        if (enableAutofill && !hasAutofilled.current && config?.userData) {
            hasAutofilled.current = true;
            filled = autofillValues(form, filled, config);
        }
        return normalizeValues(form, filled, true, config);
    }, [form, values, config, enableAutofill]);
    useEffect(() => {
        const hasAnyValueChanged = !deepEqual(normalizedValues, values);
        if (hasAnyValueChanged) {
            onChange?.(normalizedValues);
        }
    }, [values, normalizedValues, onChange]);
    return normalizedValues;
};
//# sourceMappingURL=use-form-values.js.map